module.exports = __webpack_public_path__ + "img/logo2.f46ddd46.png";